import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { ssColorWhite, ssColorCyan, mainFontFamily } from '../constants/style-constants';
import { hunit } from '../lib/style-helpers';
import { Plus } from './UiIcons';

const Button = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${ssColorWhite};
  cursor: pointer;
  display: flex;
  font-size: 18px;
  font-family: ${mainFontFamily};
  min-height: 50px;
  letter-spacing: 1px;
  padding: 0 ${hunit(2)};
  text-transform: uppercase;

  &:hover {
    color: ${ssColorCyan};
  }
`;

const plusIconCss = css`
  flex-shrink: 0;
  height: 18px;
  margin-left: ${hunit(3)};
  width: 18px;

  line {
    stroke: ${ssColorCyan};
  }
`;

const MoreButton = ({ text, ...restProps }) => (
  <Button type="button" {...restProps}>
    {text}
    {' '}
    <Plus css={plusIconCss} />
  </Button>
);

MoreButton.propTypes = {
  text: PropTypes.string.isRequired,
};

export default MoreButton;
